<template>
  <section class="podcast-section">
    <div class="podcast-section__content">
      <MediaInfo
        class="podcast-section__content__info"
        :title="title"
        :mediaType="$t('general.labels.podcast')"
        :introText="introText"
        :icon="audio"
        iconSize="1.4rem"
        @playMedia="playMedia"
      >
        <MediaTime :durationInSeconds="audioDuration" />
      </MediaInfo>

      <CtaExtra
        v-if="currentPage === 'download-multimedia'"
        class="podcast-section__content__extra"
        black
        :internalUrlParam="relatedPage"
      />
    </div>

    <Transition name="fade">
      <PodcastPanel
        v-if="playing"
        :title="title"
        :audioFileName="audioFileName"
        :interviewee="interviewee"
        @onClose="playing = false"
      />
    </Transition>
  </section>
</template>

<script setup>
import { ref, onMounted, inject, computed } from "vue";
import { pushData } from "@/utilities/analytics-functions.js";

import MediaInfo from "../general/MediaInfo.vue";
import MediaTime from "../general/MediaTime.vue";
import CtaExtra from "../general/CtaExtra.vue";
import PodcastPanel from "../general/PodcastPanel.vue";

import { audio } from "@/assets/icons/icons.js";

const props = defineProps({
  title: String,
  introText: String,
  interviewee: String,
  currentPage: String,
  relatedPage: String
});

const $baseUrl = inject("$baseUrl");
const playing = ref(false);
const audioDuration = ref(0);

// const audioFileName = computed(() => `${props.currentPage}_podcast`)
const audioFileName = computed(() => `eccellenza-operativa_podcast`);

onMounted(() => getPodcastDuration());

function playMedia() {
  playing.value = true;
  pushData(
    "podcast",
    `${$baseUrl}audio/${audioFileName.value}.mp3`,
    props.title
  );
}

function getPodcastDuration() {
  const audioEl = new Audio(`${$baseUrl}audio/${audioFileName.value}.mp3`);

  audioEl.onloadeddata = () => {
    audioDuration.value = audioEl.duration;
  };

  audioEl.remove();
}
</script>

<style lang="scss" scoped>
.podcast-section {
  --podcast-border: 1px solid var(--scala-grigi-gray-2);

  padding: 0 var(--page-padding-h);
  background: var(--page-gradient);
  color: var(--white-100);

  .download-multimedia & {
    background: var(--white-100);
    border-top: var(--podcast-border);
    border-bottom: var(--podcast-border);
    color: var(--black-100);
  }

  &__content {
    padding: 7vh 2.5rem;

    .download-multimedia & {
      padding: 7vh 5vw;
      border-left: var(--podcast-border);
      border-right: var(--podcast-border);
    }

    &__info {
      padding-bottom: 1.75rem;
      max-width: toRem(400);
    }

    &__duration {
      margin-bottom: 1rem;
    }

    &__extra {
      border-top: var(--podcast-border);
      padding-top: 1.75rem;
    }
  }
}
</style>
